import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function scuolaNewReducer(state = {}, action) {
  switch (action.type) {
    case types.LOAD_SCUOLA_DATA_NEW_SUCCESS:
      return action.schoolData;
    case types.APP_CLEAR:
      return {};
    case types.SCUOLA_CLEAR:
      return {};

    default:
      return state;
  }
}
